import { gql } from "@/__generated__/gql";

export const PROFILE_ANSWERS_QUERY = gql(`
  query ProfileAnswers($userId: ID!) {
    node(id: $userId) {
      ... on User {
        id
        profileAnswers(
          filter: FUN_FACTS
          ordering: { field: UPDATED_AT, direction: DESC }
          first: 50
        ) {
          nodes {
            id
            text
            question {
              id
              text
            }
          }
        }
      }
    }
  }
`);
